"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationLayerDiv = AnimationLayerDiv;
const React = __importStar(require("react"));
const BASE_STYLE = {
    width: "100%",
    height: "100%",
};
const getCssVariableStyle = (cssVariables) => {
    const result = {
        width: "100%",
        height: "100%",
    };
    for (const [key, value] of Object.entries(cssVariables)) {
        result[`--${key}`] = value;
    }
    return result;
};
function AnimationLayerDiv({ layer, onEnd, children, }) {
    const handleAnimationEnd = React.useCallback((event) => {
        // only handle events from this div, not bubbled from children
        if (event.currentTarget === event.target && layer) {
            onEnd(layer.name);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [layer === null || layer === void 0 ? void 0 : layer.name, onEnd]);
    return (React.createElement("div", { className: layer === null || layer === void 0 ? void 0 : layer.className, style: (layer === null || layer === void 0 ? void 0 : layer.cssVariables)
            ? getCssVariableStyle(layer.cssVariables)
            : BASE_STYLE, onAnimationEnd: layer ? handleAnimationEnd : undefined }, children));
}
